import React from "react";

// reactstrap components
import { Table, Badge, Button, Input } from "reactstrap";
import NumberFormat from "react-number-format";

class ShoppingRules extends React.Component {
    onEditKeyUp(e, index) {
        const charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        if (charCode === 13) {
            this.props.onEditSave(index);
        } else if (charCode === 27) {
            this.props.onEditCancel();
        }
    }

    render() {
        const rules = this.props.rules || [];
        const warehouses = this.props.warehouses || [];
        const { editingIndex, editingDraft } = this.props;

        return (
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                    <tr>
                        <th scope="col">Produk</th>
                        <th scope="col">Warehouse</th>
                        <th scope="col">Batas Harga / Bulan</th>
                        <th scope="col">Batas Stok / Bulan</th>
                        <th scope="col" className="text-right">Aksi</th>
                    </tr>
                </thead>
                <tbody>
                    {rules.length === 0 && (
                        <tr>
                            <td colSpan="5" className="text-center text-muted py-4">
                                Belum ada produk dengan batas belanja.
                            </td>
                        </tr>
                    )}
                    {rules.map((rule, index) => {
                        const warehouse = warehouses.find((w) => w.warehouse_id === rule.warehouse_id);
                        const isEditing = editingIndex === index;

                        return (
                            <tr key={`${rule.product_id}-${rule.warehouse_id}`}>
                                <th scope="row">{rule.product_name || `Produk #${rule.product_id}`}</th>
                                <td>{warehouse?.warehouse_name || `Warehouse #${rule.warehouse_id}`}</td>
                                <td>
                                    {isEditing ? (
                                        <Input
                                            bsSize="sm"
                                            placeholder="0 = tanpa batas"
                                            name="price_limitation"
                                            autoFocus
                                            value={editingDraft.price_limitation}
                                            onChange={(e) => this.props.onEditChange(e)}
                                            onKeyUp={(e) => this.onEditKeyUp(e, index)}
                                            type="text"
                                        />
                                    ) : rule.price_limitation > 0 ? (
                                        <NumberFormat
                                            value={rule.price_limitation}
                                            displayType="text"
                                            thousandSeparator
                                            prefix="Rp "
                                        />
                                    ) : (
                                        <Badge color="secondary">Tanpa batas</Badge>
                                    )}
                                </td>
                                <td>
                                    {isEditing ? (
                                        <Input
                                            bsSize="sm"
                                            placeholder="0 = tanpa batas"
                                            name="stock_limitation"
                                            value={editingDraft.stock_limitation}
                                            onChange={(e) => this.props.onEditChange(e)}
                                            onKeyUp={(e) => this.onEditKeyUp(e, index)}
                                            type="text"
                                        />
                                    ) : rule.stock_limitation > 0 ? (
                                        rule.stock_limitation
                                    ) : (
                                        <Badge color="secondary">Tanpa batas</Badge>
                                    )}
                                </td>
                                <td className="text-right">
                                    {isEditing ? (
                                        <>
                                            <Button
                                                color="primary"
                                                size="sm"
                                                outline
                                                type="button"
                                                className="mr-2"
                                                onClick={() => this.props.onEditSave(index)}
                                            >
                                                Simpan
                                            </Button>
                                            <Button
                                                color="secondary"
                                                size="sm"
                                                outline
                                                type="button"
                                                onClick={() => this.props.onEditCancel()}
                                            >
                                                Batal
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Button
                                                color="info"
                                                size="sm"
                                                outline
                                                type="button"
                                                className="mr-2"
                                                disabled={editingIndex !== null && editingIndex !== undefined}
                                                onClick={() => this.props.onEditStart(index)}
                                            >
                                                Ubah
                                            </Button>
                                            <Button
                                                color="danger"
                                                size="sm"
                                                outline
                                                type="button"
                                                disabled={editingIndex !== null && editingIndex !== undefined}
                                                onClick={() => this.props.onRemove(index)}
                                            >
                                                Hapus
                                            </Button>
                                        </>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }
}

export default ShoppingRules;
